export const pillars = ['Spalla', 'Ginocchio', 'Caviglia', 'Colonna', 'Anca', 'Gomito'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Spalla 360 (The Shoulder Blueprint)',
  desc: 'Comprendi la meccanica della spalla passo dopo passo. Valuta, riabilita e riporta i tuoi atleti ai movimenti di spinta con sicurezza.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Gomito e Polso (Upper Limb Recovery)',
  desc: 'Prendi decisioni cliniche reali per epicondiliti e tunnel carpale. Metti in atto il tuo primo protocollo senza dubitare delle progressioni.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Schiena Forte (The Spine Shield)',
  desc: 'Un quadro organizzato per gestire lombalgie ed ernie discali con criteri di progressione chiari per avanzare senza perdersi.'
}, {
  n: 4,
  emoji: '📓',
  title: 'Anca e Bacino (The Hip Engine)',
  desc: "Domina la mobilità dell'anca, l'attivazione dei glutei e la stabilità pelvica per costruire protocolli senza esitazioni."
}, {
  n: 5,
  emoji: '📗',
  title: 'Ginocchio 360 (The Knee Fortress)',
  desc: 'Gestisci lesioni del LCA, LCM e tendine rotuleo con protocolli di carico progressivo. Evita gli errori classici di prescrizione.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Caviglia e Piede (The Ankle Command)',
  desc: "Protocolli per distorsioni, riprogrammazione propriocettiva e criteri di ritorno alla corsa utilizzati nello sport d'élite."
}];
export const volumeIncludes = ['Protocolli visivi passo dopo passo', 'Criteri di valutazione clinica', 'Checkpoint di progressione', 'Esempi reali di ritorno allo sport', 'Checklist di pratica quotidiana', 'Schede di monitoraggio stampabili'];
export const bonuses = [{
  n: '01',
  title: "Il Ricettario dell'Atleta",
  desc: 'Alimentazione Anti-Infiammatoria per accelerare la guarigione dei tessuti.',
  price: '27€',
  cover: 'https://cdn.magicpatterns.com/uploads/pSt76P2FjUujrHx4V2AN6H/BONO_1.webp'
}, {
  n: '02',
  title: 'Protocollo Sonno Rigenerativo',
  desc: 'Ottimizza il riposo per massimizzare la riparazione cellulare notturna.',
  price: '25€',
  cover: 'https://cdn.magicpatterns.com/uploads/79RTo1TD5KK4D9fiEPJxvw/BONO_2.webp'
}, {
  n: '03',
  title: 'Guida Crioterapia e Termoterapia',
  desc: 'Gestione professionale del ghiaccio e del calore a casa.',
  price: '20€',
  cover: 'https://cdn.magicpatterns.com/uploads/vhLHWGiqT5WU5ueRqB1HWV/BONO_3.webp'
}, {
  n: '04',
  title: 'Diario di Allenamento e Tracker',
  desc: 'Sistema di monitoraggio costante per evitare stalli nel recupero.',
  price: '22€',
  cover: 'https://cdn.magicpatterns.com/uploads/kJnkENMsJ3zvEp9y1pGUdt/BONO_4.webp'
}, {
  n: '05',
  title: 'La Routine di 10 Minuti',
  desc: 'Riscaldamento specifico e stretching dinamico per ogni sport.',
  price: '20€',
  cover: 'https://cdn.magicpatterns.com/uploads/uWQe3pctFBgNS1EuvcpnQT/BONO_5.webp'
}];
